import { DirectionKind } from '~/common/enums/enums';

const DIRECTIONS = [DirectionKind.JS, DirectionKind.QA] as const;

export { DIRECTIONS };
